import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateEnvironment } from "../../models/environments/CreateEnvironment";
import { UpdateEnvironment } from "../../models/environments/UpdateEnvironment";


const RESOURCE_NAME = 'environment';

const getAll = () => {
    const http = getAxiosInstance();
    return http.get(`${RESOURCE_NAME}/getAll`, requestConfig());
  };

const create = (model: CreateEnvironment) => {
    const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/create`, model, requestConfig());
};

const update = (model: UpdateEnvironment) => {
    const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/update/${model.id}`, model, requestConfig());
};

const remove = (id: number) => {
    const http = getAxiosInstance();
    return http.delete(`${RESOURCE_NAME}/delete/${id}`, requestConfig());
  }

const EnvironmentService = {
  getAll,
  create,
  update,
  remove,
};
export default EnvironmentService;